import { IonContent, IonIcon, IonPopover } from '@ionic/react'
import React, { useRef, useState } from 'react'
import { IRatingProps } from './rating-props.interface'
import './rating.scss'
import { ellipse } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'

const Rating: React.FC<IRatingProps> = ({ value }) => {
  const popover = useRef<HTMLIonPopoverElement>(null)
  const [popoverOpen, setPopoverOpen] = useState(false)
  const { t } = useTranslation()
  const openPopover = (e: React.MouseEvent) => {
    popover.current!.event = e
    setPopoverOpen(true)
  }
  const closePopover = () => {
    setPopoverOpen(false)
  }

  return (
    <div className="rating" onMouseEnter={openPopover} onMouseLeave={closePopover}>
      <IonIcon icon={ellipse} />
      <span>{value}</span>
      <IonPopover
        className="rating_popover"
        onDidDismiss={closePopover}
        side="bottom"
        alignment="center"
        ref={popover}
        isOpen={popoverOpen}
      >
        <IonContent className="rating_popover_content">{t('rating')}</IonContent>
      </IonPopover>
    </div>
  )
}

export default Rating
